<template>
  <div class="p-6 bg-indigo-800 min-h-screen flex justify-center items-center">
    <div class="w-full max-w-md">
      <logo class="block mx-auto w-full max-w-xs fill-white" height="50" />
      <form class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="login">
        <div class="pt-5">
          <h1 class="text-center font-bold text-3xl">SpethBot WebApp</h1>
          <div class="mx-auto mt-1 w-24 border-b-2 " />
          <text-input v-model="form.email" :error="form.errors.email" class="hidden" label="Email" type="email" autofocus autocapitalize="off" />
          <text-input v-model="form.password" :error="form.errors.password" class="hidden" label="Password" type="password" />
          <label class="select-none flex items-center" for="remember">
            <input id="remember" v-model="form.remember" class="mr-1 hidden" type="checkbox" />
            <span class="text-sm hidden">Remember Me</span>
          </label>
        </div>
        <div>
          <iframe :src='twitch_url' height="252" width="500" allowfullscreen="allowfullscreen" class="my-5 block mx-auto w-full  fill-white"></iframe>
          </div>
        <div class="px-10 py-4 bg-gray-100 border-t border-gray-100 flex">
        <inertia-link class="block ml-auto" :href="route('login.twitch')"><button class="ml-auto btn-indigo">Login with Twitch</button></inertia-link>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Login' },
  components: {
    LoadingButton,
    Logo,
    TextInput,
  },
  data() {
    return {
      form: this.$inertia.form({
        email: '',
        password: '',
        remember: false,
      }),
    };
  },
  methods: {
    login() {
      this.form.post(this.route('login.store'))
    },
  },
  computed: {
    twitch_url() {
      return "https://player.twitch.tv/?channel="+ this.$page.props.twitch.twitch_channel +"&parent="+this.$page.props.helper.domain+"&muted=true";
    },
  },
}
</script>
